import request from "@/utils/request";
import { Message } from "element-ui";

// 控销
// external-sales-rule 获取业务员列表
export function getSalesUser(data) {
  return request({
    url: `/external-sales-rule/salesUser/page`,
    method: "POST",
    data: data,
  });
}

// /salesUser/examineSalesUser 审核业务员
export function examineSalesUser(data) {
  return request({
    url: `/external-sales-rule/salesUser/examineSalesUser`,
    method: "PUT",
    data: data,
  });
}
// 查询业务员详情
export function querySalesUserByPhoneAsName(params) {
  return request({
    url: `/external-sales-rule/salesUser/querySalesUserByPhoneAsName`,
    method: "GET",
    params,
  });
}
// 查询业务员负责商品类型 和 客户类型

export function getCustomerAndGoodsType(params) {
  return request({
    url: `/shop/shoptype/getCustomerAndGoodsType`,
    method: "GET",
    params,
  });
}

//根据商户查询数据权限判断前端按钮展示
export function buttonView() {
  return request({
    url: `/external-sales-rule/sales/auth/button/view`,
    method: "GET",
  });
}

// /salesExtend/page 分页查询控销推广信息

export function getSalesExtend(data) {
  return request({
    url: `/external-sales-rule/salesExtend/page`,
    method: "POST",
    data: data,
  });
}

// salesExtend  新增控销推广信息 (海报ops)
export function salesExtendAdd(data) {
  return request({
    url: `/external-sales-rule/salesExtend`,
    method: "POST",
    data: data,
  });
}

// salesExtend 修改控销推广信息 (海报ops)
export function salesExtendUpdate(data) {
  return request({
    url: `/external-sales-rule/salesExtend`,
    method: "PUT",
    data: data,
  });
}

// /sales/auth/page 数据权限控制管理 查询

export function queryAuthPage(params) {
  return request({
    url: `/external-sales-rule/sales/auth/page`,
    method: "GET",
    params,
  });
}

// /salesExtend/{id} 控销推广信息 删除
export function salesExtendDelete(data) {
  return request({
    url: `/external-sales-rule/salesExtend/${data.id}`,
    method: "DELETE",
  });
}

//查看控销推广设置信息
export function querySalesExtendSettings(params) {
  return request({
    url: `/external-sales-rule/salesExtendSettings/querySalesExtendSettings`,
    method: "GET",
    params,
  });
}

// /salesExtendSettings  新增控销推广设置信息
export function salesExtendSettings(data) {
  return request({
    url: `/external-sales-rule/salesExtendSettings`,
    method: "POST",
    data,
  });
}

// /salesExtendSettingsUpdate  修改控销推广设置信息
export function salesExtendSettingsUpdate(data) {
  return request({
    url: `/external-sales-rule/salesExtendSettings`,
    method: "PUT",
    data,
  });
}

//数据权限控制管理- 新增规则
export function salesAuthAdd(data) {
  return request({
    url: `/external-sales-rule/sales/auth`,
    method: "POST",
    data,
  });
}

//数据权限控制管理- 修改规则
export function salesAuthUpdate(data) {
  return request({
    url: `/external-sales-rule/sales/auth`,
    method: "PUT",
    data,
  });
}

///sales/area/sys/audit 审核控销商品规则
export function salesAreaSysAudit(data) {
  return request({
    url: `/external-sales-rule/sales/area/sys/audit`,
    method: "PUT",
    data,
  });
}

//分页查询海报
export function salesPosterInfoPage(data) {
  return request({
    url: `/external-sales-rule/poster/salesposterinfo/page`,
    method: "GET",
    params: data,
  });
}

// /poster/salesposterinfo/check

export function salesPosterInfoCheck(data) {
  return request({
    url: `/external-sales-rule/poster/salesposterinfo/check`,
    method: "PUT",
    data: data,
  });
}

// 完税证明下载
export function queryPayTaxeCertificate(data) {
  return request({
    url: `/external-sales-rule/salesAgree/downloadPayTaxeCertificate`,
    method: "get",
    responseType: "blob",
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const contentDisposition = response.headers["content-disposition"];
    const fileName = decodeURIComponent(
      contentDisposition.substring(contentDisposition.indexOf("=") + 1)
    );
    console.log(fileName);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function () {
      URL.revokeObjectURL(blob);
      Message.success("下载成功！");
      document.body.removeChild(link);
    }, 0);
  });
}

// 查询详情
export function salesposterinfo(id) {
  return request({
    url: `/external-sales-rule/poster/salesposterinfo/${id}`,
    method: "get",
  });
}

export function externalInfo(id) {
  return request({
    url: `/product/sales/external/info/${id}`,
    method: "get",
  });
}

//业务员数据统计
export function getSalesDataStatistics() {
  return request({
    url: `/external-sales-rule/salesStatistics/salesDataStatistics`,
    method: "get",
  });
}

//业务员统计管理
export function getSalesUserStatisticsManage(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserStatisticsManage`,
    method: "POST",
    data,
  });
}

//根据查询条件查询业务员客户列表分页
export function getSalesUserStatisticsManageBySalesIdPage(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserStatisticsManageBySalesIdPage`,
    method: "POST",
    data,
  });
}

//根据查询条件查询业务员客户列表分页
export function getSalesClientListPage(data) {
  return request({
    url: `/statistic/com/ops/client/getSalesClientListPage`,
    method: "POST",
    data,
  });
}

//根据业务员id查询业务员接品信息
export function getSalesUserReceiveGoodsManageBySalesId(salesUserId) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserReceiveGoodsManageBySalesId/${salesUserId}`,
    method: "GET",
  });
}

//根据查询条件查下团员信息分页
export function getSalesUserMemberInformationBySalesIdPage(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserMemberInformationBySalesIdPage`,
    method: "POST",
    data,
  });
}

//根据查询条件查询上下级业务员信息
export function getSalesUserParentInformationBySalesId(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserParentInformationBySalesId`,
    method: "POST",
    data,
  });
}

//根据查询条件查询上下级业务员信息
export function getSalesUserDetailsBySalesIdVO(salesUserId) {
  return request({
    url: `/external-sales-rule/salesStatistics/salesUserDetailsBySalesIdVO/${salesUserId}`,
    method: "GET",
  });
}

//根据联系方式查询业务员信息
export function querySalesUserMsg(params) {
  return request({
    url: `/external-sales-rule/salesStatistics/querySalesUserMsg`,
    method: "GET",
    params,
  });
}

//父级业务员变更
export function parentSalesUserAlter(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/parentSalesUserAlter`,
    method: "POST",
    data,
  });
}

//业务员客户转移
export function customerTransfer(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/customerTransfer`,
    method: "POST",
    data,
  });
}

//查询认证列表
export function queryAuthenticationInformation(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/queryAuthenticationInformation`,
    method: "POST",
    data,
  });
}

//查询提现明细
export function queryWithdrawalStatement(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/queryWithdrawalStatement`,
    method: "POST",
    data,
  });
}

//客户关联业务员
export function customerRelationSalesUser(data) {
  return request({
    url: `/external-sales-rule/salesStatistics/customerRelationSalesUser`,
    method: "POST",
    data,
  });
}

// 查看业务员收入明细
export function queryIncomeDetail(data) {
  return request({
    url: `/statistic/salesUser/income/page`,
    method: "POST",
    data,
  });
}

//

// 根据shopId查询所有部门
export function getAllDepts(shopId) {
  return request({
    url: `/external-sales-rule/dept/externalsalesdeptinfo/allDeptIds/${shopId}`,
    method: "GET",
    params: {},
  });
}
